import React from "react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import QuestionMarkIcon from "@app/images/picto/question-circle-fill.svg";

/**
 * Display Tool Tip
 * @param {title} Tooltip title
 * @param {description} Tooltip description
 * @returns 
 */
export default function ToolTip({title, description, placement="right"}) {    
    const renderTooltip = (props) => (
        <Tooltip {...props}>
            <div className="tooltip-title">
                {title}
            </div>            
            <div className="tooltip-desc">
                {description}
            </div>
        </Tooltip>
      );
    
      return (
        <OverlayTrigger
          placement={placement}
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <input type="image" src={QuestionMarkIcon} />
        </OverlayTrigger>
      );
}